import ClienteController from "@/shared/controllers/cliente/clienteController";
import EVENTS from "@/shared/events/events";
import { defineComponent } from "vue";

const name = "cliente-dropdown";

export default defineComponent({
  name,

  components: {},

  props: {
    empresaId:{
      type: String,
      default: '',
    },
    representanteId:{
      type:String,
      default: ''
    },
    limparDropdown: {
      type: Number,
      default: 0
    },
    modelValue: {
      type: [String],
      default: '',
    },
  },

  mounted() {
    this.representanteIdInterno = !this.representanteId ? this.$store.state.representanteSelecionadoId : this.representanteId;
    this.mitt.on(EVENTS.cliente.limparDropdown, () => {
      this.clienteId = undefined;
      this.atualizaModel();
      this.ClientesArray = [];
    });
  },

  updated() {},

  data() {
    return {
      ClientesArray: [],
      timer: null,
      clienteId: undefined,
      representanteIdInterno: ''
    };
  },

  methods: {
    atualizaModel(){
      this.$emit('update:modelValue', this.clienteId)
    },

    atualizaRepresentante(){
      this.representanteIdInterno = this.representanteId;
    },

    resetaDropdown(){
      this.ClientesArray = [];
      this.clienteId = undefined;
      this.atualizaModel();
    },

    atualizaCliente(){
      this.clienteId = this.modelValue;
    },

    buscarClientes(event) {
      if(!event){
        this.resetaDropdown();
        return;
      }
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ClienteController.getClienteDropDownsByNome(event,this.representanteIdInterno, this.empresaId).requisicao
        .then(res => {
          this.ClientesArray = res.data.data;
        })
        .catch(() => {
          this.resetaDropdown();
        });
      }, 1000);
    },
  },

  computed: {},

  watch:{
    representanteId(){
      this.atualizaRepresentante();
    },

    modelValue(){
      this.atualizaCliente();
    },

    limparDropdown(){
      this.resetaDropdown();
    }

  }
});
